export default __webpack_public_path__ + "static/media/Slide-3.ab811c5d.jpg";